export const enum SnPullProtocol {
  RTMP = 'RTMP',
  RTSP = 'RTSP',
}
